"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAudioContext = exports.intervalInRange = exports.roundInterval = exports.clamp = exports.lerp = exports.browser = exports.mod = exports.choice = undefined;

var _tone = require("tone");

var _tone2 = _interopRequireDefault(_tone);

var _startAudioContext = require("./startAudioContext");

var _startAudioContext2 = _interopRequireDefault(_startAudioContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utilities
 * @module lib/util.js;
 */

var isIphone = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
var isIpad = navigator.userAgent.match(/iPad/i);
var isAndroid = navigator.userAgent.match(/Android/i);
var isMobile = isIphone || isIpad || isAndroid;
var isDesktop = !isMobile;

document.body.classList.add(isMobile ? "mobile" : "desktop");

var browser = { isIphone: isIphone, isIpad: isIpad, isMobile: isMobile, isDesktop: isDesktop };

function choice(a) {
  return a[Math.floor(Math.random() * a.length)];
}
function mod(n, m) {
  return n - m * Math.floor(n / m);
}
function roundInterval(interval) {
  return Math.round(interval * 10000000);
}
var intervalInRange = function intervalInRange(interval, root) {
  return 20 < interval * root && interval * root < 20000;
};
var lerp = function lerp(n, a, b) {
  return (b - a) * n + a;
};
var clamp = function clamp(n) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return n < a ? a : n < b ? n : b;
};

function requestAudioContext(fn) {
  if (window.location.protocol !== "https:") {
    var container = document.createElement("div");
    var button = document.createElement("div");
    button.innerHTML = "Tap to start - please unmute your phone";
    Object.assign(container.style, {
      display: "block",
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: "10000",
      top: "0px",
      left: "0px",
      backgroundColor: "rgba(0, 0, 0, 0.8)"
    });
    Object.assign(button.style, {
      display: "block",
      position: "absolute",
      left: "50%",
      top: "50%",
      padding: "20px",
      backgroundColor: "#7F33ED",
      color: "white",
      fontFamily: "monospace",
      borderRadius: "3px",
      transform: "translate3D(-50%,-50%,0)",
      textAlign: "center",
      lineHeight: "1.5",
      width: "150px"
    });
    container.appendChild(button);
    document.body.appendChild(container);
    _startAudioContext2.default.setContext(_tone2.default.context);
    _startAudioContext2.default.on(button);
    _startAudioContext2.default.onStarted(function (_) {
      container.remove();
      fn();
    });
  } else {
    fn();
  }
}

exports.choice = choice;
exports.mod = mod;
exports.browser = browser;
exports.lerp = lerp;
exports.clamp = clamp;
exports.roundInterval = roundInterval;
exports.intervalInRange = intervalInRange;
exports.requestAudioContext = requestAudioContext;


//////////////////
// WEBPACK FOOTER
// ./client/lib/util.js
// module id = 109
// module chunks = 0